export default function AccountTabs({
  accounts,
  selectedAccountId,
  onSelect,
  className = "",
  indexStatusById = null,
}) {
  const allTabs = [{ account_id: "all", label: "All Accounts" }].concat(
    (accounts || []).map((a) => ({
      account_id: a.account_id,
      label: a.email || `${a.provider} (${a.account_id})`,
    }))
  );

  return (
    <div className={`overflow-x-auto ${className}`}>
      <div className="inline-flex min-w-full sm:min-w-0 border border-border bg-background">
        {allTabs.map((a) => {
          const active = selectedAccountId === a.account_id;
          const status = indexStatusById ? indexStatusById[a.account_id] : null;
          return (
            <button
              key={a.account_id}
              type="button"
              onClick={() => onSelect(a.account_id)}
              className={`px-3 py-2 text-xs sm:text-sm font-mono border-r border-border whitespace-nowrap transition-colors flex items-center gap-1.5 ${
                active
                  ? "bg-foreground text-background"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary/40"
              }`}
              data-testid={`account-tab-${a.account_id}`}
            >
              {a.label}
              {status === "indexing" && (
                <span title="Indexing in the background" data-testid={`account-tab-indexing-${a.account_id}`}>⏳</span>
              )}
              {status === "complete" && (
                <span title="Fully indexed" data-testid={`account-tab-complete-${a.account_id}`}>✓</span>
              )}
              {status === "error" && (
                <span title="Indexing stalled — needs retry" data-testid={`account-tab-error-${a.account_id}`}>⚠️</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
